import { render, staticRenderFns } from "./dom.md?vue&type=template&id=5d989911&"
import script from "./dom.md?vue&type=script&lang=js&"
export * from "./dom.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d989911')) {
      api.createRecord('5d989911', component.options)
    } else {
      api.reload('5d989911', component.options)
    }
    module.hot.accept("./dom.md?vue&type=template&id=5d989911&", function () {
      api.rerender('5d989911', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/more/test/dom.md"
export default component.exports